import React, { useState } from "react"
import Icon from "@components/UI/Icon"
import css from "@utils/css"

const Collapse = ({ title, className, children }) => {
  const [visible, setVisible] = useState(null)

  const toggleVisible = () => {
    if (visible === "visible") {
      setVisible(null)
    } else if (!visible) {
      setVisible("visible")
    }
  }

  return (
    <div className={css("group border-2 border-solid border-neutral-300 rounded-[8px]", className, visible)}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <div
        role="button"
        tabIndex={0}
        onClick={toggleVisible}
        className="flex justify-between items-center p-4 cursor-pointer"
      >
        <h4 className="h4 !m-0">{title}</h4>
        <Icon
          size={16}
          name="chevron-down"
          color="neutral-700"
          className="group-[.visible]:rotate-180"
        />
      </div>
      <div className="px-4 pb-4 hidden group-[.visible]:block">{children}</div>
    </div>
  )
}

export default Collapse
